export default __webpack_public_path__ + "static/media/img_04.b895f857.jpg";